import React from 'react';

const Row = ({ children, gap = 4, align = 'flex-start', style = {}, ...rest }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: align,
                gap,
                width: '100%',
                ...style,
            }}
            {...rest}
        >
            {children}
        </div>
    );
};


Row.Item = ({
    children,
    flexGrow,
    flexShrink = 0,
    flexBasis,
    minWidth,
    maxWidth,
    width,
    height,
    style = {},
    className,
    ...rest
}) => {
    const itemStyle = {
        ...(flexGrow !== undefined && { flexGrow }),
        ...(flexShrink !== undefined && { flexShrink }),
        ...(flexBasis !== undefined && { flexBasis }),
        ...(minWidth && { minWidth }),
        ...(maxWidth && { maxWidth }),
        ...(width && { width }),
        ...(height && { height }),
        ...style,
    };

    return (
        <div style={{...itemStyle, "overflow" : "hidden"}} className={className} {...rest}>
            {children}
        </div>
    );
};

export default Row;
